import * as React from "react";
import * as Loadable from "react-loadable";

import { Loader } from "semantic-ui-react";

function LoadingComponent(props) {
	if (props.error) {
		// When the loader has errored
		return (
			<div>
				Error! <button onClick={props.retry}>Retry</button>
			</div>
		);
	} else if (props.timedOut) {
		// When the loader has taken longer than the timeout
		return <Loader>Loading...</Loader>;
	} else if (props.pastDelay) {
		// When the loader has taken longer than the delay
		return <Loader />;
	} else {
		// When the loader has just started
		return null;
	}
}

const defaults = {
	loading: LoadingComponent,
	delay: 2000,
	timeout: 10
};

const WithLoadable = opts => {
	return Loadable(Object.assign(defaults, opts));
};

export default WithLoadable;



// WEBPACK FOOTER //
// ./src/helpers/WithLoadable.tsx